export default __webpack_public_path__ + "static/scalable_cloud-ddbf8c64bbe23ce2cf805d7cacd5dc49.webp";